<template>
	<router-view/>
</template>

<style src="./stylesheets/Common.css" />
<style src="./stylesheets/Box.css" />
<style src="./stylesheets/InlineText.css" />
<style src="./stylesheets/Table.css" />
<style src="./stylesheets/Form.css" />
<style src="./stylesheets/List.css" />